<script lang="ts" setup>
import { useSidebarStore } from '~/stores/sidebar';
import { ref } from 'vue';

const hover = ref(false);
</script>

<template>
  <div :data-hover="hover" @mouseover="hover = true" @mouseleave="hover = false" class="transition flex-shrink-0 flex h-64 bg-white border-r border-gray-200">
    <slot :hover="hover"></slot>
  </div>
</template>
